import React, { memo } from "react";
import { useChooseLevelPage } from "./index.hooks";
import { LevelButton, PageWrapper } from "components";
import { Container, Grid, Stack, Typography } from "@mui/material";
import { levels } from "config/levels";

type ChooseLevelPageProps = {};

export const ChooseLevelPage = memo(({}: ChooseLevelPageProps) => {
  const {} = useChooseLevelPage();

  return (
    <PageWrapper>
      <Container maxWidth="md" sx={{ pb: "1em" }}>
        <Stack dir="column">
          <Typography
            variant="h5"
            sx={{
              fontSize: {
                xs: 18,
                md: 30,
              },
              marginBottom: {
                xs: "30px",
                md: "65px",
              },
            }}
          >
            Scegli cosa realizzare
          </Typography>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <Stack spacing={2} alignItems="center">
                {levels.map((level, index) =>
                  index < levels.length / 2 ? (
                    <LevelButton key={level.name} level={level} />
                  ) : null,
                )}
              </Stack>
            </Grid>
            <Grid item xs={12} md={6}>
              <Stack spacing={2} alignItems="center">
                {levels.map((level, index) =>
                  index >= levels.length / 2 ? (
                    <LevelButton key={level.name} level={level} />
                  ) : null,
                )}
              </Stack>
            </Grid>
          </Grid>
        </Stack>
      </Container>
    </PageWrapper>
  );
});
